import { TransactionDetailScreen } from "@/screens/dashboard/TransactionDetailScreen";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/dashboard/transactions/detail/$transactionId"
)({
  component: TransactionDetailScreen,
  loader: async ({ params }) => {
    return {
      crumb: "Detail Transaksi",
      transactionId: params.transactionId,
    };
  },
});

